import {
  type Layer,
  type StandardChartLayerSpec,
  defineStandardChartLayer
} from '../../../core/layer';
import DEFINE from '../../../util/DEFINE';

const visInfo: Layer['visInfo'] = {
  id: 'treeMap',
  name_zh: '矩形树图',
  name_en: 'TreeMap',
  types_en: [],
  purpose_en: [],
  purpose_zh: [],
  standers: '',
  rules: {
    data: amount => amount > 1,
    x: amount => amount > 1,
    y: amount => amount > 1
  },
  /** 保证和 Spec.encoding 字段一致 */
  parameters: {
    x: {
      itemType: [DEFINE.STR],
      category: DEFINE.SINGLE
    },
    y: {
      itemType: [DEFINE.NUMBER],
      category: DEFINE.SINGLE
    },
    color: {
      itemType: [DEFINE.NUMBER],
      category: DEFINE.SINGLE,
      optional: true
    }
  }
};

/** 暂不支持legend的点击功能 */
export interface Spec extends StandardChartLayerSpec {
  encoding: {
    x: string;
    y: string;
    color?: string;
  };
}

export const treeMap = defineStandardChartLayer<Spec>({
  type: visInfo.id,
  isIndependentLayer: true,
  visInfo,
  render(api, spec) {
    const { data: dataArray, util, hook } = api;
    const {
      dataIndex = 0,
      encoding: { x, y, color }
    } = spec;
    const data = dataArray[dataIndex];
    const dataMetaInfo = hook.parseDataMetaInfo(data);

    // * ------------------------- data
    const seriesData = data.values.map((item, index) => {
      return {
        name: item[x],
        value: +item[y],
        color: color ? item[color] : undefined
      };
    });

    // * ------------------------- chart
    return {
      tooltip: {
        trigger: 'item',
        formatter: params => {
          const series = Array.isArray(params) ? params : [params];
          const items = [];

          series.forEach(item => {
            const result = hook.formatDataNumberValue(item.value, {
              type: 'table',
              unit: dataMetaInfo[item.seriesName]?.unit
            });
            items.push({
              type: util.const.SERIES_2_LEGEND_TYPE_MAP[item.seriesType],
              color: item.color,
              name: item.name,
              value: result.value + result.unit
            });
          });

          return hook.buildTooltip({
            config: hook.buildStandardChartPresetOption(api).tooltip,
            title: '',
            items
          });
        }
      },
      xAxis: [],
      yAxis: [],
      series: [
        {
          type: 'treemap',
          AIGCEncoding: spec.encoding,
          roam: false,
          nodeClick: false,
          width: '100%',
          height: '100%',
          label: {
            formatter: params_ => {
              const result = hook.formatDataNumberValue(params_.data.value, {
                type: 'table',
                unit: dataMetaInfo[y]?.unit
              });
              const unit = dataMetaInfo[y]?.unit ? dataMetaInfo[y].unit : '';
              return `${params_.data.name}\n\n${result.value + result.unit + unit}`;
            }
          },
          // 矩形图元文本高度超过矩形块高度则直接隐藏文本
          labelLayout: params => {
            if (params.labelRect.height > params.rect.height) {
              return {
                fontSize: 0
              };
            }
          },
          breadcrumb: {
            show: false
          },
          data: seriesData
        }
      ]
    };
  }
});
